module.exports = __webpack_public_path__ + "media/img/logo-transparent-lg-dark-f59ce4ae7208ef259670f017747e6115.png";